import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Порядок импортов существенный: сначала ресет и шрифт, потом приложение.
// Стили antd инжектятся в рантайме при первом рендере компонента, и ресет,
// импортированный после App, оказался бы в каскаде ниже них.
import "./app/styles/global.css";
// Self-hosted, а не с CDN: админку открывают с рабочих машин, в том числе из
// сетей, где внешние шрифтовые CDN закрыты, и без шрифта вёрстка едет.
import "@fontsource-variable/inter";

import { App } from "./app/App";

const container = document.getElementById("root");
if (container === null) throw new Error("Не найден #root");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
